

export class MenuAccessDetail implements IMenuAccessDetail {
    canAccess!: boolean;
    canAdd!: boolean;
    canEdit!: boolean;
    canDelete!: boolean;

    constructor(data?: IMenuAccessDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
            this.canAdd = _data["canAdd"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): MenuAccessDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MenuAccessDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        data["canAdd"] = this.canAdd;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        return data; 
    }
}

export interface IMenuAccessDetail {
    canAccess: boolean;
    canAdd: boolean;
    canEdit: boolean;
    canDelete: boolean;
}

